@if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-table-display
        [columns]="columns"
        [loading]="dataService.loading()"
        [data]="listings()"
        [state]="widgetState()"
        [maxRows]="8"
        [totalRows]="totalListings()"
        [isEmpty]="totalListings() === 0"
        icon="fa-solid fa-ban"
        emptyStateIcon="fa-regular fa-hexagon-check"
        [totalItemsTranslationKey]="'dashboard.visuals.components.table.totalItems.unpublishedListingsByDays'"
        [emptyMessageTranslationKey]="'dashboard.visuals.components.table.noData.unpublishedListingsByDays'"
    />
}
